import React from 'react';

export default function OuvidoriaMonitoramento() {
  return (
    <div style={{
      minHeight: '100vh', background: '#f8fafc', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 10, padding: 40, textAlign: 'center',
    }}>
      <div style={{ fontSize: 54 }}>🚧</div>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 800, color: '#1e293b', margin: 0 }}>Ouvidoria Monitoramento</h1>
      <p style={{ color: '#64748b', fontSize: '0.9rem', maxWidth: 380 }}>Esta tela está em desenvolvimento.</p>
    </div>
  );
}
